<template>
  <button class="save-button">Save Contact</button>
</template>

<script>
export default {
  name: "the-save-button",
};
</script>

<style scoped>
.save-button {
  padding: 5px;
  outline: none;
  border-radius: 5px;
  font-size: 16px;
  margin: 0;
  background-color: rgb(255, 227, 175);
  border: 1px solid rgb(218, 178, 145);
  color: rgb(131, 91, 59);
}
</style>
